import Container from '@/components/Container';

const Loading = () => {
  return (
    <Container className="h-full">
      <div className="col-span-12 flex items-center justify-center">
        <div className="flex max-h-[90vh] w-full max-w-[430px] flex-col items-start overflow-auto rounded-2xl bg-gray-200 p-8">
          <div className="mb-16 h-10 w-[56%] animate-pulse self-center rounded bg-gray-400"></div>

          <div className="mb-8 w-full">
            <div className="mb-2 h-6 w-32 animate-pulse rounded bg-gray-400"></div>
            <div className="h-4 w-48 animate-pulse rounded bg-gray-400"></div>
          </div>

          <div className="mb-5 w-full">
            <div className="mb-2 h-4 w-20 animate-pulse rounded bg-gray-400"></div>
            <div className="h-10 w-full animate-pulse rounded bg-gray-400"></div>
          </div>

          <div className="mb-9 w-full">
            <div className="mb-2 h-4 w-24 animate-pulse rounded bg-gray-400"></div>
            <div className="h-10 w-full animate-pulse rounded bg-gray-400"></div>
          </div>

          <div className="mb-4 h-12 w-full animate-pulse rounded bg-gray-400"></div>

          <div className="h-3 w-36 animate-pulse rounded bg-gray-400"></div>

          <div className="mt-4 flex gap-1">
            <div className="h-3 w-32 animate-pulse rounded bg-gray-400"></div>
            <div className="h-3 w-20 animate-pulse rounded bg-gray-400"></div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Loading;
